export default __webpack_public_path__ + "static/media/NovoUsuarios.e5540aec.svg";